import { RefObject, useState } from "react";

import useResizeObserver from "./useResizeObserver";

const useBreakpoint = <T extends Element = HTMLDivElement>(
  ref: RefObject<T>,
  minWidth: number,
  initial = false
) => {
  const [match, setMatch] = useState<boolean>(initial);

  // useEffect(() => {
  //   const handle = () => {
  //     if (window.innerWidth < minWidth) {
  //       setMatch(true);
  //     } else {
  //       setMatch(false);
  //     }
  //   };
  //   window.addEventListener("resize", handle);
  //   return () => window.removeEventListener("resize", handle);
  // }, [minWidth]);

  useResizeObserver({
    ref,
    onResize: (size) =>
      requestAnimationFrame(() => {
        setMatch(size.width ? size.width < minWidth : false);
      }),
  });

  return match;
};

export default useBreakpoint;
